<div class="c-subheader">
  <span class="c-subheader__title">{{ title }}</span>
  <span class="c-subheader__description">{{ description }}</span>
</div>
